import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useTimeInLockerStyles = makeStyles<Theme, { fontSize: 'normal' | 'small' }>({
  card: {
    width: '100%',
    padding: '16px',
    borderRadius: '10px',
    minHeight: '150px',
    height: 'max-content'
  },
  subtitle: {
    margin: '8px 0 0 0',
    fontSize: '14px',
    color: '#A8A8A8',
    marginBottom({ fontSize }) {
      return fontSize === 'normal' ? 0 : '8px';
    }
  },
  duration: {
    fontSize({ fontSize }) {
      return fontSize === 'normal' ? '42px' : '32px';
    },
    marginBottom: '-8px',
    width: '100%',
    maxWidth: '400px'
  }
});
